import { Text } from "@chakra-ui/react";
import React from "react";

import { ModalContainer } from "../ModalContainer";

interface PaymentStatusConfirmationModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  type: "bulk" | "individual";
  selectedDate?: string;
  isLoading?: boolean;
}

export const PaymentStatusConfirmationModal: React.FC<
  PaymentStatusConfirmationModalProps
> = ({ isOpen, onClose, onConfirm, type, selectedDate, isLoading = false }) => {
  const title =
    type === "bulk" ? (
      <>
        Are you sure you want to mark all studies completed on or before{" "}
        <Text as="span" color="brandYellow.500">
          {selectedDate}
        </Text>{" "}
        as paid?
      </>
    ) : (
      "Are you sure you want to mark this study as paid?"
    );

  return (
    <ModalContainer
      isOpen={isOpen}
      onClose={onClose}
      title={title}
      leftButtonTitle="No"
      rightButtonTitle="Yes"
      onClickLeftButton={onClose}
      onClickRightButton={onConfirm}
      leftButtonEnabled={!isLoading}
      rightButtonEnabled={!isLoading}
    />
  );
};
